import { ShigoPermission } from '../../features/auth/permissions';
import { ShigoNavigationItem, type ShigoNavigationEntry } from './shigo-navigation.types';

export const adsTxtNavigationEntry: ShigoNavigationEntry = {
  id: ShigoNavigationItem.SupplyAdsTxt,
  labelKey: 'nav.supply.adsTxt',
  to: ({ can }) => {
    if (can(ShigoPermission.SupplyAdsTxtAppsRead)) return '/supply/ads-txt/apps';
    if (can(ShigoPermission.SupplyAdsTxtRecordsRead)) return '/supply/ads-txt/records';
    return '/supply/ads-txt/domains';
  },
  activePaths: ['/supply/ads-txt'],
  access: [
    {
      permissions: [ShigoPermission.SupplyAdsTxtRead, ShigoPermission.SupplyAdsTxtAppsRead],
    },
    {
      permissions: [ShigoPermission.SupplyAdsTxtRead, ShigoPermission.SupplyAdsTxtRecordsRead],
    },
    {
      permissions: [ShigoPermission.SupplyAdsTxtRead, ShigoPermission.SupplyAdsTxtDomainsRead],
    },
  ],
};
